import { render, staticRenderFns } from "./domainTool.html?vue&type=template&id=4680d3f1&scoped=true&"
import script from "./domainTool.js?vue&type=script&lang=js&"
export * from "./domainTool.js?vue&type=script&lang=js&"
import style0 from "./domainTool.scss?vue&type=style&index=0&id=4680d3f1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4680d3f1",
  null
  
)

export default component.exports